import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { riskBranchId } from '../api';
import endPoints from '../api/endpoint';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { ApiStatus, RiskCenterState } from '../types';
import { notify } from '../Utils/toastify';

import { setCommonDataLoader } from './commonSlice';
import store from './store';

dayjs.extend(utc);

const initialState: RiskCenterState = {
  status: false,
  activeEventsData: {},
  apiStatus: ApiStatus.idle,
  activeLocations: {},
  productions: {},
  activeProductions: {},
  inactiveProductions: {},
  upcomingProductions: {},
  userTypeList: {},
  contactList: {},
  userList: {},
  branchDetaildata: {},
  grupsLists: {},
  serviceList: {},
  serviceDetails: {},
  loader: false,
  orderList: {},
  accesslist: {},
  businessAddress: {},
  orderLocation: {},
  deliveryCheck: {},
  schdulesTypes: {},
  cartDetails: {},
  cabService: {},
  viewshiftdetails: {},
  similarserviceDetails: {},
  cabBookingDetails: {},
};
const riskCenterSlice = createSlice({
  name: 'riskCenter',
  initialState,
  reducers: {
    resetRiskCenterState: () => initialState,
    activeEvents: (state, action) => {
      const { payload }: any = action;
      state.activeEventsData = payload;
    },
    activeProductionLocations: (state, action) => {
      const { payload }: any = action;
      state.activeLocations = payload;
    },
    setProductionList: (state, action) => {
      const { payload }: any = action;
      state.productions = payload;
    },

    setProductionListingsActive: (state, action) => {
      const { payload }: any = action;
      state.activeProductions = payload;
    },
    setProductionListingsInactive: (state, action) => {
      const { payload }: any = action;
      state.inactiveProductions = payload;
    },
    setProductionListingsUpcoming: (state, action) => {
      const { payload }: any = action;
      state.upcomingProductions = payload;
    },
    updateApiStatus: (state, action) => {
      const { payload } = action;
      state.apiStatus = payload;
    },
    setUserTypeContactList: (state, action) => {
      const { payload } = action;
      state.userList = payload;
    },
    setContactList: (state, action) => {
      const { payload } = action;
      state.contactList = payload;
    },
    setUserTypeList: (state, action) => {
      const { payload } = action;
      state.userTypeList = payload;
    },
    setAccessList: (state, action) => {
      const { payload } = action;
      state.accesslist = payload;
    },
    setBranchDetailData: (state, action) => {
      const { payload } = action;
      state.branchDetaildata = payload;
    },
    setVendorGroups: (state, action) => {
      const { payload } = action;
      state.grupsLists = payload;
    },
    setServicesList: (state, action) => {
      const { payload } = action;
      state.serviceList = payload;
    },
    setServiceDetails: (state, action) => {
      const { payload } = action;
      state.serviceDetails = payload;
    },
    setSimilarServiceDetails: (state, action) => {
      const { payload } = action;
      state.similarserviceDetails = payload;
    },
    setLoaderStatus: (state, action) => {
      const { payload } = action;
      state.loader = payload;
    },
    setOrderList: (state, action) => {
      const { payload } = action;
      state.orderList = payload;
    },
    setBusniessAddress: (state, action) => {
      const { payload } = action;
      state.businessAddress = payload;
    },
    setOrderLocation: (state, action) => {
      const { payload } = action;
      state.orderLocation = payload;
    },
    setDeliveryCheck: (state, action) => {
      const { payload } = action;
      state.deliveryCheck = payload;
    },
    setSchdulesTypes: (state, action) => {
      const { payload } = action;
      state.schdulesTypes = payload;
    },

    setCartDetails: (state, action) => {
      const { payload } = action;
      state.cartDetails = payload;
    },
    setCabService: (state, action) => {
      const { payload } = action;
      state.cabService = payload;
    },
    setViewShiftDetails: (state, action) => {
      const { payload } = action;
      state.viewshiftdetails = payload;
    },
    setCabBookingDetails: (state, action) => {
      const { payload } = action;
      state.cabBookingDetails = payload;
    },
  },
});
export const {
  activeEvents,
  activeProductionLocations,
  setProductionListingsActive,
  setProductionListingsInactive,
  setProductionListingsUpcoming,
  setProductionList,
  setUserTypeContactList,
  setContactList,
  setUserTypeList,
  setBranchDetailData,
  setVendorGroups,
  setServicesList,
  setServiceDetails,
  setLoaderStatus,
  setOrderList,
  setAccessList,
  resetRiskCenterState,
  setBusniessAddress,
  setOrderLocation,
  setDeliveryCheck,
  setSchdulesTypes,
  setCartDetails,
  setCabService,
  setViewShiftDetails,
  setSimilarServiceDetails,
  setCabBookingDetails,
} = riskCenterSlice.actions;

export const getActiveEventsAndAdvisors = (id: string) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.activeEventsAndAdvisor;

  // Make the API call
  getApiCall(
    `${apiendpoint}?studioId=${id}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(activeEvents(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getActiveProductionLocations = (id?: string) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.productionLocations;

  // Make the API call
  getApiCall(
    `${apiendpoint}?studioId=${id}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(activeProductionLocations(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      } else {
        notify(null, 'error');
      }
    },
  );
};

export const getAllProductions = (
  query = '?page=1&limit=10',
  status: any,
  id?: string,
  cb?: any,
) => {
  const { dispatch } = store;

  // Build the API endpoint with the query and studioId
  let apiendpoint = `${endPoints.riskCenter.productions}${query}&studioId=${id}`;

  // Add status to the endpoint if it's not 0 or null
  if (status && status !== 0) {
    apiendpoint += '&status=' + `${status}`;
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        if (status === 'ACTIVE') {
          dispatch(setProductionListingsActive(data.data));
        } else if (status === 'COMPLETED') {
          dispatch(setProductionListingsInactive(data.data));
        } else if (status === 'INACTIVE') {
          dispatch(setProductionListingsUpcoming(data.data));
        } else {
          // If status is null or 0, dispatch the general studio list action
          dispatch(setProductionList(data.data));
        }
        // Callback after dispatch
        cb(data.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        //notify(e?.data.message, 'error')
      }
    },
  );
};

export const getUserTypeContactList = (id?: string) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.userTypeContactList;
  dispatch(setLoaderStatus(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}?productionId=${id}`,
    (s: any) => {
      dispatch(setLoaderStatus(false));
      const { data } = s;
      if (data?.data) {
        dispatch(setUserTypeContactList(data?.data));
      }
    },
    (e: any) => {
      dispatch(setLoaderStatus(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getContactList = (
  query = '?pageNo=1&limit=9',
  id: string | any,
  userId?: string | any | undefined,
  searchkey?: string | any,
) => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));

  // Build the API endpoint with the query and studioId
  let apiendpoint = `${endPoints.riskCenter.contactList}${query}&productionId=${id}`;

  // Add status to the endpoint if it's not 0 or null
  if (userId) {
    apiendpoint += `&riskCenterUserTypeId=${userId}`;
  }
  if (searchkey) {
    apiendpoint += `&searchKey=${searchkey}`;
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setCommonDataLoader(false));
        dispatch(setContactList(data?.data));
      }
    },
    (e: any) => {
      dispatch(setCommonDataLoader(false));
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const addUserType = (values: any, setValue: any, cb?: any) => {
  postApiCall(
    endPoints.riskCenter.addUserType,
    values,
    (s: any) => {
      const {
        data: { statusCode, message, data },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        setValue('riskCenterUserTypeId', { _id: data?._id, name: data?.name });
        if (cb) cb();
      } else if (statusCode && statusCode === 409) {
        notify('Add different user type', 'error');
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getOrderListings = (
  id?: string,
  date?: Date,
  _productionId?: any,
) => {
  const { dispatch, getState } = store;
  const { selectedTalentUser } = getState().common;

  // Ensure date is always the current date if not provided
  const selectedDate = date ? new Date(date) : new Date();

  // Set start time to 00:00:00 and end time to 23:59:59
  // selectedDate.setHours(0, 0, 0, 0);
  const startTimeISO = `${dayjs(selectedDate).format(
    'YYYY-MM-DD',
  )}T00:00:00.000Z`;
  // selectedDate.toISOString()

  // selectedDate.setHours(23, 59, 59, 999);
  const endTimeISO = `${dayjs(selectedDate).format(
    'YYYY-MM-DD',
  )}T23:59:59.000Z`;
  // selectedDate.toISOString()

  // startTime: start + 'T00:00:00.000Z',
  // endTime: start + 'T23:59:59.000Z',

  const apiendpoint =
    `${endPoints.riskCenter.orderList}?riskCenterUserId=${selectedTalentUser?.userDetail?.[0]?._id}` +
    `&startTime=${startTimeISO}&endTime=${endTimeISO}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setOrderList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getUserTypeList = (id?: string) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.addUserType;

  // Make the API call
  getApiCall(
    `${apiendpoint}?productionId=${id}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setUserTypeList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getAccessListManagement = (
  id?: string,
  searchKey?: any,
  cb?: any,
) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.accessList;

  // Construct query string based on provided parameters
  const queryParams = [`productionId=${id}`];
  if (searchKey) {
    queryParams.push(`searchKey=${searchKey}`);
  }
  const queryString = queryParams.join('&');

  // Make the API call
  getApiCall(
    `${apiendpoint}?${queryString}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        if (cb) cb();
        dispatch(setAccessList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getBranchDetails = (id?: string) => {
  if (!id) {
    console.error('getBranchDetails called without an id');
    return;
  }
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.branchdetails(id);

  dispatch(setCommonDataLoader(true));
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setBranchDetailData(data?.data));
        dispatch(setCommonDataLoader(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setCommonDataLoader(false));
      }
    },
  );
};

export const getVendorGroups = (id?: string, query?: string) => {
  if (!id) {
    console.error('getVendorGroups called without an id');
    return;
  }
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.vendorGroups(id);

  if (query) {
    apiendpoint = apiendpoint + query;
  }
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setVendorGroups(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getServiceList = (
  id?: string,
  query?: string,
  searchKey?: any,
) => {
  if (!id) {
    console.error('getServiceList called without an id');
    return;
  }
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.vendorServiceLists(id);

  if (query) {
    apiendpoint = apiendpoint + query;
  }
  if (searchKey) {
    apiendpoint += `&searchKey=${searchKey}`;
  }
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setServicesList(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getServiceDetails = (id?: string, cb?: any) => {
  if (!id) {
    console.error('getServiceDetails called without an id');
    return;
  }
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.serviceDetails(id);
  dispatch(setServiceDetails({}));
  dispatch(setLoaderStatus(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setServiceDetails(data?.data));
        dispatch(setLoaderStatus(false));
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const getSimilarServices = () => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.serviceDetailsimilar;

  dispatch(setLoaderStatus(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setSimilarServiceDetails(data?.data));
        dispatch(setLoaderStatus(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const checkDeliverability = (data: any, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.checkDeliverability;

  const payload = {
    lat: data?.latitude || 0,
    long: data?.longitude || 0,
    branchId: data?.branchId || riskBranchId,
  };

  // Make the API call
  postApiCall(
    `${apiendpoint}`,
    payload,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setDeliveryCheck(data?.data));
        dispatch(setLoaderStatus(false));
        if (!data?.data?.isDeliverable) {
          if (cb) cb(true);
        } else {
          if (cb) cb(false);
        }
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const checkDeliverabilityInCart = (data: any) => {
  return new Promise((resolve, reject) => {
    const { dispatch } = store;
    const apiendpoint = endPoints.riskCenter.checkDeliverability;

    const payload = {
      lat: data?.latitude || 0,
      long: data?.longitude || 0,
      branchId: data?.branchId || riskBranchId,
    };

    postApiCall(
      `${apiendpoint}`,
      payload,
      (s: any) => {
        const { data } = s;
        if (data?.data) {
          dispatch(setDeliveryCheck(data?.data));
          dispatch(setLoaderStatus(false));
          resolve(data?.data); // Resolve with the data
        }
      },
      (e: any) => {
        if (e?.data && e?.data.message) {
          notify(e?.data.message, 'error');
          dispatch(setLoaderStatus(false));
          reject(e); // Reject on error
        }
      },
    );
  });
};

export const getBusinessAddress = (id?: string, cb?: any) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.businessAddress;

  if (id) {
    apiendpoint = `${apiendpoint}?productionId=${id}`;
  }
  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setBusniessAddress(data?.data));
        dispatch(setLoaderStatus(false));
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const updateAccessList = (values: any, cb?: any) => {
  putApiCall(
    `${endPoints.riskCenter.updateAccessList}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const orderLocationMethod = (data: any) => {
  const { dispatch } = store;
  dispatch(setOrderLocation(data));
};

export const getSchdules = (query?: string, cb?: any, errorcb?: any) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.schedules;

  if (query) {
    apiendpoint = apiendpoint + query;
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setSchdulesTypes(data?.data));
        dispatch(setLoaderStatus(false));
        cb(data?.data);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorcb?.();
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const addToCart = (
  payload: any,
  cb?: () => void,
  errCb?: () => void,
) => {
  postApiCall(
    `${endPoints.riskCenter.addToCart}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Added to cart', 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
      if (errCb) errCb();
    },
  );
};

export const getCart = (isLoading?: boolean) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.cart;
  if (isLoading) {
    dispatch(setCommonDataLoader(true));
  }

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      if (isLoading) {
        dispatch(setCommonDataLoader(false));
      }

      if (data?.data) {
        dispatch(setCartDetails(data?.data));
        dispatch(setLoaderStatus(false));
      }
    },
    (e: any) => {
      if (isLoading) {
        dispatch(setCommonDataLoader(false));
      }
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export const updateCartNotes = (cartId: string | any, values: any) => {
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/note`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateServiceNotes = (cartId: string | any, values: any) => {
  putApiCall(
    `${endPoints.riskCenter.cart}/${cartId}/change-service-period`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getViewShiftDetails = (
  cartIds?: string,
  dateRange?: { from: any; to: any },
) => {
  const { dispatch } = store;
  let apiendpoint = endPoints.riskCenter.shiftDetail;

  if (!dateRange) {
    console.error('Date range is required for fetching shift details.');
    return;
  }

  // Ensure `from` and `to` are Dayjs instances
  const from = dayjs(dateRange.from);
  const to = dayjs(dateRange.to);

  apiendpoint = `${apiendpoint}?fromDate=${from
    .startOf('day')
    .valueOf()}&toDate=${to.endOf('day').valueOf()}`;

  if (cartIds) {
    apiendpoint += `&cartIds=${cartIds}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        dispatch(setViewShiftDetails(data?.data));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateCabService = (type: string | any, data: any) => {
  const { dispatch, getState } = store;

  dispatch(
    setCabService({ ...getState()?.riskCenter.cabService, [type]: data }),
  );
};

export const placeOrder = (values: any, cb?: any) => {
  postApiCall(
    endPoints.riskCenter.order,
    values,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Added to Cart', 'success');

        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const draftCart = (cb?: any) => {
  postApiCall(
    endPoints.riskCenter.draft,
    {},
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const updateDescription = (values: any, cb?: any) => {
  postApiCall(
    `${endPoints.riskCenter.addDescription}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        notify(message, 'success');

        if (cb) cb();
        getCart(false);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const addToCabOrder = (payload: any, reset: any, cb?: () => void) => {
  postApiCall(
    `${endPoints.riskCenter.bookCabService}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Cab Book Successfully.', 'success');
        reset();
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getCabBookingDetails = (id: string, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.bookingDetails(id);

  dispatch(setLoaderStatus(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        cb(data?.data);
        dispatch(setCabBookingDetails(data?.data));
        dispatch(setLoaderStatus(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        dispatch(setLoaderStatus(false));
      }
    },
  );
};

export default riskCenterSlice.reducer;
